function registerInfoWindowStyling(infoWindow, contentID) {
  if(infoWindow.domreadyListener)
    google.maps.event.removeListener(infoWindow.domreadyListener);
  infoWindow.domreadyListener = google.maps.event.addListener(infoWindow, "domready", function() {
    // Telkens het infowindow opnieuw opgebouwd, en getoond wordt, wordt deze callback functie aangeroepen
    // Deze past de stijl aan. Let op, zoeken naar de divs die aangepast moeten worden is niet echt simpel en moet evt. veranderen bij een update van Google Maps. Dit is ondertussen al minstens 1 maal gebeurd.
    // var contentDiv, iw, bct, bbg, closebutton, dHeight;
    var contentDiv = document.getElementById(contentID);
    var b = {}, p, iw;
    b.content = contentDiv && contentDiv.parentNode && contentDiv.parentNode.parentNode; // content (text)
    if(iw = b.content && b.content.parentNode) {
      if(contentDiv.offsetWidth!=b.content.offsetWidth) contentDiv.firstChild.style.whiteSpace='normal';
      dHeight = contentDiv.scrollHeight- b.content.offsetHeight;
      b.background = iw.firstChild && iw.firstChild.lastChild;
      b.shadow = iw.firstChild && iw.firstChild.firstChild.nextSibling;
      b.closebutton = iw.childNodes[2];
      // bubble = b;
      if(b.background && b.closebutton) {
        for(p in b)
          if(b[p] && b.hasOwnProperty(p)) b[p].className = b[p].className + ' ' + 'infowindow-'+p;
        // change height:
        // 1) move top up
        // 2) move bottom back down (except for closebutton)
        setTimeout(function() {
          var h, p;
          for(p in b) {
            if(!b[p].style) continue;
            if(dHeight!=0) {
              b[p].style.top = (b[p].offsetTop-dHeight)+"px";
              if(p!='closebutton'&&(p!='content'||dHeight>0)) b[p].style.height = (b[p].offsetHeight+dHeight)+"px";
            }
            if(p=='content' && b[p].offsetHeight < b[p].scrollHeight) {
              b[p].style.height = b[p].scrollHeight +"px";
            }
          }
        }, 0);
      } 
    }
  });
}
